import React, {useEffect, useState} from 'react'
import Market from './market'
import TimePrice from './timePrice'
import {message, Modal, Tabs} from 'antd'
import {ContactsOutlined, IdcardOutlined} from '@ant-design/icons'
import PackageSetting from './packageSetting'
import TableInfoView from './tableInfoView/tableInfoView'
import {reservationTableSetting} from '../../../api/bookings'
import {checkBookingsValues, checkTableInfoValues, postBooksInfo, postTableInfo,} from '../postData'
import BookSettings from './bookSettings/BookSettings'
import {useClubTableBookSettingContext} from './bookSettings/store/useClubTableBookSettingContext'

const {TabPane} = Tabs
const OK = 1

const ClubTableModal = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [curTabKey, setCurTabKey] = useState(1)
    const [bookingsInfo, setBookingsInfo] = useState(null)
    const [postBookingsData, setPostBookingsData] = useState(null)
    const [tableInfoData, setTableInfoData] = useState(null)
    const [isShowReserve, setIsShowReserve] = useState(false)

    const {updateTableReservationSetting, form} = useClubTableBookSettingContext()

    useEffect(() => {
        props.fetchCheckInterval(props.record.table_id) // 分时段价格
        getBookingsInfo()
        setIsShowReserve(true)
    }, [])

    const onTabClick = (value) => {
        setCurTabKey(+value)
    }

    const getBookingsInfo = async () => {
        const {status, detail, data} = await reservationTableSetting(props.record.table_id)
        if (status !== OK) {
            message.error(detail)
            return
        }
        setBookingsInfo(data)
    }

    const clickHandleOk = async () => {
        if (curTabKey === 1) {
            tableInfoPostMethod()
            return
        }
        if (curTabKey === 5) {
            await updateTableReservationSetting([props.record.table_id], props.hideBookSettingsModal)
            return
        }
        props.handleOk(curTabKey)
    }

    const tableInfoPostMethod = () => {
        if (!checkTableInfoValues(tableInfoData)) {
            return
        }
        setIsLoading(true)
        postTableInfo(tableInfoData, (flag) => {
            setIsLoading(false)
            if (flag) {
                props.handleOk(curTabKey)
            }
        })
    }


    const bookPostMethod = () => {
        const {reservationProperty} = postBookingsData
        let flag = true
        if (reservationProperty.canReservation) {
            if (!checkBookingsValues(postBookingsData)) {
                flag = false
            }
        }
        if (!flag) {
            return
        }

        setIsLoading(true)
        postBooksInfo(postBookingsData, (flag) => {
            setIsLoading(false)
            if (flag) {
                props.handleOk(curTabKey)
            }
        })
    }

    const onBookingsDataChange = (data) => {
        setPostBookingsData(data)
    }

    const onTableDataChange = (data) => {
        setTableInfoData(data)
    }

    const handleCancel = () => {
        props.handleCancel()
        form.resetFields()
    }

    const {visible, record, timePrice, walletType, tableDetailInfo} = props

    return (
        <Modal
            title={record.name}
            visible={visible}
            onOk={clickHandleOk}
            onCancel={handleCancel}
            width={
                curTabKey === 4
                    ? '90vw'
                    : curTabKey === 5
                        ? '1400px'
                        : '1000px'
            }
            confirmLoading={isLoading}
        >
            <Tabs defaultActiveKey="1" onTabClick={onTabClick}>
                <TabPane
                    tab={
                        <span>
              <IdcardOutlined/>
              基本信息
            </span>
                    }
                    key="1"
                >
                    <TableInfoView
                        tableInfoData={tableDetailInfo}
                        onDataChange={onTableDataChange}
                    />
                </TabPane>
                <TabPane
                    tab={
                        <span>
              <ContactsOutlined/>
              价格设置
            </span>
                    }
                    key="2"
                >
                    <TimePrice
                        record={record}
                        tableDetailInfo={tableDetailInfo}
                        timePrice={timePrice}
                        fetchDeleteInterval={props.fetchDeleteInterval}
                        fetchAddTimeInterval={props.fetchAddTimeInterval}
                        fetchUpdateInterval={props.fetchUpdateInterval}
                    />
                </TabPane>
                <TabPane
                    tab={
                        <span>
              <ContactsOutlined/>
              销售设置
            </span>
                    }
                    key="3"
                >
                    <Market
                        record={record}
                        walletType={walletType}
                        handleCheckbox={props.handleCheckbox}
                    />
                </TabPane>
                <TabPane
                    tab={
                        <span>
              <ContactsOutlined/>
              套餐设置
            </span>
                    }
                    key="4"
                >
                    <PackageSetting record={record} {...props} />
                </TabPane>
                {isShowReserve && (
                    <TabPane
                        tab={
                            <span>
                <ContactsOutlined/>
                预订设置
              </span>
                        }
                        key="5"
                    >
                        <BookSettings tableIds={[record.table_id]}/>
                    </TabPane>
                )}
            </Tabs>
        </Modal>
    )
}

export default ClubTableModal


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/modalDetail.js